import { mapToId } from '@witmetrics/utils/arrays';
import { isEmpty } from '@witmetrics/utils/misc';
import {
  useFileNotesFromProjectIdArray,
  useKeypointsFromProjectIdArray,
  useLeadProjects,
  useNotesFromProjectIdArray,
} from '@witmetrics/data-store';
import { useAppState } from '@/providers/AppStateProvider';
import NotesTimeline from '@/components/NotesTimeline';
import Card from '@/components/Card';
import TimelineToggle from './TimelineToggle';
import { classes, useTimelineSettings } from './utils';

export default function TimelineSection() {
  const { activeLeadId } = useAppState();
  const projects = useLeadProjects(activeLeadId);
  const keypoints = useKeypointsFromProjectIdArray(mapToId(projects));
  const notes = useNotesFromProjectIdArray(mapToId(projects));
  const fileNotes = useFileNotesFromProjectIdArray(mapToId(projects));
  const [timelineSettings, setTimelineSettings] = useTimelineSettings();

  const renderContent = () => {
    if (isEmpty([...notes, ...fileNotes, ...keypoints])) {
      return (
        <div className={classes.message}>
          No notes or keypoints for current patient.
        </div>
      );
    }
    return (
      <NotesTimeline
        showProject
        className={classes.timeline}
        timelineSettings={timelineSettings || 'ALL'}
        keypoints={keypoints}
        notes={notes}
        fileNotes={fileNotes}
      />
    );
  };

  if (!activeLeadId) return null;

  return (
    <Card className={classes.card}>
      <div className={classes.titleBlock}>
        <h4 className={classes.title}>Timeline</h4>
        <TimelineToggle
          value={timelineSettings!}
          onChange={setTimelineSettings}
        />
      </div>
      {renderContent()}
    </Card>
  );
}
